import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";

export default [
  {
    path: "/wt-star-level-center",
    name: "StarLevelCenter",
    meta: {
      title: "星级中心",
      showLevelGrowing: true,
      theme: "transparent",
      keepAlive: true,
      includeStatusBar: true,
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "star-level" */ "@/views/mine/star-level/StarLevelCenter.vue"
      )
  },
  {
    path: "/wt-growth-detail",
    name: "GrowthDetail",
    meta: {
      title: "成长值明细",
      showGrowthDetail: true,
      theme: "transparent-dark",
      keepAlive: true,
      background: getThemeBgColor //"linear-gradient(to right, #FFD700, #FFCA00)",
      // transition: true
    },
    component: () =>
      import(
        /* webpackChunkName: "star-level" */ "@/views/mine/star-level/GrowthDetail.vue"
      )
  },
  {
    path: "/wt-growth-desc",
    name: "GrowthDesc",
    meta: {
      title: "如何获得成长值？",
      showHeader: true
      // transition: true
    },
    component: () =>
      import(
        /* webpackChunkName: "star-level" */ "@/views/mine/star-level/GrowthDesc.vue"
      )
  }
];
